import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    maxWidth: '35rem',
    margin: 'auto',
  },
  description: {
    fontSize: '0.8125rem',
    fontWeight: 500,
  },
  priceDescription: {
    fontSize: '0.75rem',
    color: theme.palette.text.secondary,
  },
}));

const switchLabel = makeStyles((theme) => ({
  label: { fontWeight: 500, fontSize: 14 },
}));

export { useStyles, switchLabel };
